/**
 * @param {string | null | undefined} iso
 */
export function formatSaleHistoryDate(iso) {
  if (!iso) return '—'
  return new Date(iso).toLocaleString(undefined, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

/**
 * @param {{ name?: string, phone?: string | null } | null | undefined} customer
 */
export function formatSaleHistoryGuest(customer) {
  if (!customer?.name) return 'Walk-in'
  return customer.phone ? `${customer.name} · ${customer.phone}` : customer.name
}

/**
 * @param {{ description: string }[]} [services]
 */
export function formatSaleHistoryServices(services) {
  if (!services?.length) return '—'
  return services.map((line) => line.description).join(', ')
}

/**
 * @param {{ method: string }[]} [payments]
 */
export function formatSaleHistoryPayment(payments) {
  if (!payments?.length) return '—'
  return payments.map((payment) => payment.method).join(', ')
}
